// Mark implemented's merge commit box (FR-EDIT-17). A commit's link pasted
// or typed into it becomes the SHA at its end, as the server reads it too;
// and choosing one of the commits offered above the box, or the default
// branch's head, fills it with that commit's SHA and puts the focus there,
// so the label and the value are read out. Without the bundle the server
// still takes the link, and the offered commits' short SHAs can be typed.

/** The box's id (web/spec/spec_page.rs `sha_box`). */
const BOX = "merge-sha";

/** A link ending in /commit/<sha>, a trailing slash, query or fragment
 * allowed: the server's `merge_commits::typed_sha`. */
const LINK = /\/commit\/([0-9a-fA-F]{7,40})(?:[/?#]\S*)?$/;

/** The SHA at the end of a commit's link, or null when `value` isn't one. */
export function shaFromLink(value: string): string | null {
  const sha = value.trim().match(LINK)?.[1];
  return sha === undefined ? null : sha.toLowerCase();
}

document.addEventListener("input", (event) => {
  const box = event.target;
  if (!(box instanceof HTMLInputElement) || box.id !== BOX) return;
  const sha = shaFromLink(box.value);
  if (sha !== null) box.value = sha;
});

document.addEventListener("click", (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const button = target.closest<HTMLElement>("button[data-fill-sha]");
  if (button === null) return;
  const box = document.getElementById(BOX);
  if (!(box instanceof HTMLInputElement)) return;
  event.preventDefault();
  box.value = button.dataset.fillSha ?? "";
  box.focus();
});
